/**
 * Zárt bolt mód — tiszta segédek (Jest-tel tesztelve).
 *
 * A backend kapuja (webshop_backend/shop_gate.py) dönt az adatokról; a frontend csak
 * azt választja ki, mit lát a látogató: a „Hamarosan” oldalt, a mindig elérhető
 * oldalak egyikét egy minimális keretben, vagy (staffnak) a teljes boltot egy sávval.
 */

/** Zárt boltban is elérhető útvonal-előtagok (a /admin és a /muhely külön ágon fut). */
export const ALWAYS_OPEN_PREFIXES = [
  '/bejelentkezes',
  '/elfelejtett-jelszo',
  '/jelszo-visszaallitas',
  '/adatvedelem',
  '/aszf',
  '/visszakuldesi-szabalyzat',
  '/szallitas',
  '/fizetesi-modok',
  '/hirlevel/megerosites',
  '/leiratkozas',
  // A Műhely kézi rendelésének vevője ezekre kap linket e-mailben.
  '/latvanyterv',
  '/rendeles-kovetese',
  // A bejelentkezett vevő zárt boltban is befejezheti a függő fizetését és látja a
  // rendeléseit (a backend ezeket a végpontokat a tulajdonosra szűrve nyitva hagyja).
  // A /profil NEM nyitott: a fiók többi füle (pontok, kedvencek) bolti funkció.
  '/fizetes',
  '/megrendeles-sikeres',
  '/rendelesek',
] as const;

/** Zárt boltban is megnyitható-e az útvonal (pontos egyezés vagy al-útvonal). */
export const isAlwaysOpenPath = (pathname: string): boolean => {
  const path = pathname.replace(/\/+$/, '') || '/';
  return ALWAYS_OPEN_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
};

export type GateMode = 'loading' | 'open' | 'staff-preview' | 'closed';

export interface GateInput {
  /** A bolt nyitva van-e; `undefined`, amíg a beállítás töltődik. */
  shopOpen: boolean | undefined;
  /** Aktív staff (munkatárs vagy tulajdonos) a bejelentkezett felhasználó. */
  isStaff: boolean;
  /** Van token, de a felhasználó adatai még nem jöttek meg. */
  userLoading: boolean;
}

/** Mit lásson a látogató. */
export const gateMode = ({ shopOpen, isStaff, userLoading }: GateInput): GateMode => {
  if (shopOpen === undefined) return 'loading';
  if (shopOpen) return 'open';
  if (userLoading) return 'loading';
  return isStaff ? 'staff-preview' : 'closed';
};

/** A szerver zárt-bolt válasza (503 {"code": "shop_closed"}) — az api.ts erre jelez. */
export const SHOP_CLOSED_EVENT = 'gt:shop-closed';

export const isShopClosedPayload = (data: unknown): boolean =>
  typeof data === 'object' && data !== null && (data as { code?: unknown }).code === 'shop_closed';

/** Az admin Beállítások fül közvetlen linkje (a „Bolt állapota” az első al-fül). */
export const SETTINGS_LINK = '/admin?ful=beallitasok';
